import maddyApi from '@/services/maddyApi';

const errorHandler = e => {
  if (e.response) {
    return e.response;
  } else if (e.request) {
    return e.request;
  } else {
    return e;
  }
};

export default {
  namespaced: true,
  state: {
    loading: false,
    submissions: [],
    error: null,
    studyId: '',
  },
  getters: {},
  actions: {
    async getSubmissions({ commit, rootState }, studyId) {
      commit('RESET');
      commit('SET_LOADING', true);

      const endpoint = `/studies/${studyId}/submissions`;
      try {
        const response = await maddyApi.get(endpoint);
        commit('SET_SUBMISSIONS', {
          submissions: response.data,
          studyId: rootState.study.id,
        });
      } catch (err) {
        commit('SET_ERROR', err);
        commit('SET_LOADING', false);
        return errorHandler(err);
      }
      commit('SET_LOADING', false);
    },
    async addSubmission({ commit }, payload) {
      commit('RESET');
      commit('SET_LOADING', true);

      const { id, data } = payload;

      const endpoint = `/studies/${id}/submission`;
      const options = {
        timeout: null,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      };

      try {
        const response = await maddyApi.post(endpoint, data, options);
        commit('ADD_SUBMISSION', response.data);
      } catch (err) {
        commit('SET_ERROR', errorHandler(err));
        return errorHandler(err);
      }

      commit('SET_LOADING', false);
    },
    async deleteSubmission({ commit }, payload) {
      commit('RESET');
      commit('SET_LOADING', true);

      const endpoint = `/studies/${payload.studyId}/submission/${payload.submissionId}`;
      try {
        await maddyApi.delete(endpoint);
        commit('REMOVE_SUBMISSION', payload.submissionId);
      } catch (err) {
        commit('SET_ERROR', err);
        errorHandler(err);
      }
      commit('SET_LOADING', false);
    },
    async markSubmission({ commit }, payload) {
      // commit('RESET');

      const { studyId, submissionId } = payload;
      const endpoint = `/studies/${studyId}/submission/${submissionId}/critique`;
      try {
        commit('MARK_SUBMISSION', submissionId);
        await maddyApi.post(endpoint);
      } catch (err) {
        commit('SET_ERROR', err);
        errorHandler(err);
      }
    },
  },
  mutations: {
    RESET(state) {
      state.error = null;
      state.loading = false;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_SUBMISSIONS(state, payload) {
      state.submissions = payload.submissions;
      state.studyId = payload.studyId;
    },
    ADD_SUBMISSION(state, payload) {
      state.submissions.push(payload);
    },
    REMOVE_SUBMISSION(state, payload) {
      const index = state.submissions.findIndex(x => x.id === payload);
      state.submissions.splice(index, 1);
    },
    MARK_SUBMISSION(state, payload) {
      const currentCritiqueIndex = state.submissions.findIndex(x => x.critique);
      const current = state.submissions[currentCritiqueIndex];
      const markedIndex = state.submissions.findIndex(x => x.id === payload);
      const marked = state.submissions[markedIndex];

      // If marked as critique is found
      if (currentCritiqueIndex > -1) {
        if (currentCritiqueIndex === markedIndex) {
          // Current is the same as marked
          current.critique = !current.critique;
        } else {
          current.critique = false;
          marked.critique = true;
        }
      } else {
        // There is no current submission marked for critique
        marked.critique = true;
      }
    },
  },
};
